import { render } from "./index.vue?vue&type=template&id=f6832026"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/BaseDetailQrcode/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6832026"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6832026', __exports__)) {
    api.reload('f6832026', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f6832026", () => {
    api.rerender('f6832026', render)
  })

}


export default __exports__